import './styles/main.scss';

function MainContainer({ children }: IChildren) {
  return <main className="main">{children}</main>;
}

export default MainContainer;
